import {
  Dispatch,
  useState
} from 'react';
import {LicenseTemplateController} from '../../../../api/license/license-template.controller';
import {useAsyncEffect} from '../../../../hook/use-initial-load';
import {FeatureTemplate} from '../../../../model/license/feature-template.model';
import {LicenseTemplate} from '../../../../model/license/license-template.model';
import LicenseFeatureTemplate = LicenseTemplateController.LicenseFeatureTemplate;

export namespace LicenseTemplatePageHooks {
  export const useLicenseTemplates = (): [LicenseTemplate[], Dispatch<LicenseTemplate[]>] => {
    const [licenseTemplates, setLicenseTemplates] = useState<LicenseTemplate[]>([]);
    useAsyncEffect(async () => {
      setLicenseTemplates(await fetchLicenseTemplates())
    }, []);
    return [licenseTemplates, setLicenseTemplates];
  }

  const fetchLicenseTemplates = async (): Promise<LicenseTemplate[]> =>
    (await LicenseTemplateController.queryLicenseTemplates())


  export const useFeatureTemplates = (): [FeatureTemplate[], Dispatch<FeatureTemplate[]>] => {
    const [featureTemplates, setFeatureTemplates] = useState<FeatureTemplate[]>([]);
    useAsyncEffect(async () => {
      setFeatureTemplates(await fetchFeatureTemplates())
    }, []);
    return [featureTemplates, setFeatureTemplates];
  }

  export const fetchFeatureTemplates = async (): Promise<FeatureTemplate[]> =>
    (await LicenseTemplateController.queryFeatureTemplates())

  export const useLicenseFeatureTemplates = (): [LicenseFeatureTemplate[], Dispatch<LicenseFeatureTemplate[]>] => {
    const [licenseFeatureTemplates, setLicenseFeatureTemplates] = useState<LicenseFeatureTemplate[]>([]);
    useAsyncEffect(async () => {
      setLicenseFeatureTemplates(await fetchLicenseFeatureTemplates())
    }, []);
    return [licenseFeatureTemplates, setLicenseFeatureTemplates];
  }

  export const fetchLicenseFeatureTemplates = async (): Promise<LicenseFeatureTemplate[]> =>
    (await LicenseTemplateController.queryLicenseFeatureTemplates())

}